import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import useAuthenticatedApiRequest from "../AuthenticatedApiRequest";
import TchrURL from "../TchrURL";
import { useToast } from "@/hooks/use-toast";

export type FileConvertRequest =
  | { html: string; markdown?: never; filename: string }
  | { markdown: string; html?: never; filename: string };

export interface FileConvertResponse {
  [key: string]: any;
}

const useFileConversion = () => {
  const { post } = useAuthenticatedApiRequest();
  const { t } = useTranslation();
  const toast = useToast();
  return useMutation<
    FileConvertResponse,
    Error,
    FileConvertRequest
  >({
    mutationKey: ["lesson-lab"],
    mutationFn: async (body: FileConvertRequest) => {
      const reqUrl = new TchrURL("files/convert");

      const response = await post(reqUrl,
        JSON.stringify(body),
      );
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = body.filename || "download";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      const result = { success: true };

      return result;


    },
    onMutate: async () => {
      toast.toast({
        title: t("toast.fileConversion.loading.title"),
        description: t("toast.fileConversion.loading.description")
      })
    }
  });
};

export default useFileConversion;
